(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  /* Barre d'annonce : montant restant pour la livraison à 0,01 € en point relais, mis à jour après chaque changement du panier. */
  (function () {
    const format = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' });
    function appliquer(total) {
      document.querySelectorAll('[data-s-livraison]').forEach((message) => {
        const seuil = parseInt(message.dataset.seuil || '0', 10);
        const reste = seuil - total;
        let long = message.dataset.texte;
        let court = message.dataset.texteCourt || long;
        if (total > 0 && reste > 0) {
          const montant = format.format(reste / 100);
          long = (message.dataset.texteReste || long).replace('[montant]', montant);
          court = (message.dataset.texteResteCourt || long).replace('[montant]', montant);
        } else if (total > 0 && total >= seuil) {
          long = message.dataset.texteAtteint || long;
          court = message.dataset.texteAtteintCourt || long;
        }
        const l = message.querySelector('.s-annonce__long');
        const c = message.querySelector('.s-annonce__court');
        if (l) l.textContent = long;
        if (c) c.textContent = court;
      });
    }
    function relire() {
      fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart.js' : '/cart.js', { headers: { Accept: 'application/json' } })
        .then((reponse) => reponse.json())
        .then((panier) => appliquer(panier.total_price || 0))
        .catch(() => {});
    }
    function brancher() {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, (evenement) => {
          const donnees = evenement && evenement.cartData;
          if (donnees && typeof donnees.total_price === 'number' && donnees.items) {
            appliquer(donnees.total_price);
          } else {
            relire();
          }
        });
      }
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', brancher);
    } else {
      brancher();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  /* Pied de page : bouton « Gérer les cookies » (bannière de confidentialité de Shopify), affiché seulement si elle est active */
  (function () {
    function brancher() {
      const boutons = document.querySelectorAll('[data-s-cookies]');
      if (!boutons.length) return;
      const pret = () => window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function';
      const afficher = () => {
        if (!pret()) return false;
        boutons.forEach((bouton) => {
          const item = bouton.closest('.s-pied__cookies-item');
          if (item) item.hidden = false;
          if (!bouton.dataset.sBranche) {
            bouton.dataset.sBranche = '1';
            bouton.addEventListener('click', () => window.privacyBanner.showPreferences());
          }
        });
        return true;
      };
      if (afficher()) return;
      let essais = 0;
      const minuterie = setInterval(() => {
        essais += 1;
        if (afficher() || essais > 20) clearInterval(minuterie);
      }, 500);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', brancher);
    } else {
      brancher();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /* Éditions Sésames : mega-menu à l'intention (survol avec délai, clic, clavier) et lien « Devis » */
  (function () {
    const ordinateur = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
    const DELAI_OUVERTURE = 160;
    const DELAI_FERMETURE = 280;

    function fermer(details) {
      if (!details.hasAttribute('open')) return;
      details.removeAttribute('open');
      const resume = details.querySelector('summary');
      if (resume) resume.setAttribute('aria-expanded', 'false');
    }

    function ouvrir(details) {
      document.querySelectorAll('.s-menu details[open]').forEach((autre) => {
        if (autre !== details) fermer(autre);
      });
      details.setAttribute('open', '');
      const resume = details.querySelector('summary');
      if (resume) resume.setAttribute('aria-expanded', 'true');
    }

    function brancher() {
      document.querySelectorAll('.s-menu .s-menu__entree').forEach((entree) => {
        const details = entree.querySelector('details');
        if (!details || entree.dataset.sBranche) return;
        entree.dataset.sBranche = '1';
        let minuterie;
        const resume = details.querySelector('summary');
        details.addEventListener('toggle', () => {
          if (resume) resume.setAttribute('aria-expanded', details.open ? 'true' : 'false');
        });
        entree.addEventListener('mouseenter', () => {
          if (!ordinateur.matches) return;
          clearTimeout(minuterie);
          minuterie = setTimeout(() => {
            if (!details.open) details.dataset.sParSurvol = '1';
            ouvrir(details);
          }, DELAI_OUVERTURE);
        });
        if (resume) {
          resume.addEventListener('click', (evenement) => {
            /* Souris : un clic sur une rubrique ouverte au survol la garde ouverte ; un second clic la ferme.
               Clavier (detail = 0) : comportement natif de <details>. */
            if (!ordinateur.matches || evenement.detail === 0) return;
            evenement.preventDefault();
            clearTimeout(minuterie);
            if (details.open && details.dataset.sParSurvol !== '1') {
              fermer(details);
            } else {
              ouvrir(details);
            }
            details.dataset.sParSurvol = '0';
          });
        }
        entree.addEventListener('mouseleave', () => {
          if (!ordinateur.matches) return;
          clearTimeout(minuterie);
          minuterie = setTimeout(() => {
            if (!entree.contains(document.activeElement) || document.activeElement === resume) fermer(details);
          }, DELAI_FERMETURE);
        });
        details.addEventListener('keydown', (evenement) => {
          if (evenement.key !== 'Escape') return;
          fermer(details);
          if (resume) resume.focus();
        });
      });
      document.addEventListener('click', (evenement) => {
        document.querySelectorAll('.s-menu details[open]').forEach((details) => {
          if (!details.contains(evenement.target)) fermer(details);
        });
      });
    }

    /* Compteur du lien « Devis » : tenu à jour par assets/sesames-devis-liste.js (liste « Mon devis » du navigateur). */

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', brancher);
    } else {
      brancher();
    }
    document.addEventListener('shopify:section:load', brancher);
  })();

  } catch(e) { console.error(e); }
})();
})();
